import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccess, beforeRequestError } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const proxyClient = axios.create({
  baseURL: process.env.ORDER_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

proxyClient.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)

proxyClient.interceptors.response.use(onSuccess, onError)

export let client = proxyClient



// WEBPACK FOOTER //
// ./src/api/order/client.js